import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "converter-container"
};
const _hoisted_2 = {
  class: "converter-card"
};
const _hoisted_3 = {
  class: "tabs"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  key: 0,
  class: "tab-content"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<label for=\"excel-upload\" class=\"upload-label\"><div class=\"upload-icon\"><svg viewBox=\"0 0 24 24\" width=\"48\" height=\"48\"><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" fill=\"currentColor\"></path></svg></div><p class=\"upload-text\">拖放Excel文件到这里或点击上传</p><p class=\"upload-hint\">支持 .xlsx 和 .xls 格式</p></label>", 1);
const _hoisted_7 = {
  key: 0,
  class: "result-section"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "转换结果", -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
  fill: "currentColor"
})], -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z",
  fill: "currentColor"
})], -1);
const _hoisted_11 = {
  class: "json-preview"
};
const _hoisted_12 = {
  key: 1,
  class: "tab-content"
};
const _hoisted_13 = {
  class: "input-area"
};
const _hoisted_14 = {
  class: "controls"
};
const _hoisted_15 = ["disabled"];
const _hoisted_16 = {
  key: 0,
  class: "error-message"
};
import { ref, computed, onUnmounted } from 'vue';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
  __name: 'jsonexcel',
  setup(__props) {
    const activeTab = ref('excelToJson');
    const excelData = ref([]);
    const jsonInput = ref('');
    const excelFileUrl = ref('');
    const conversionError = ref('');
    const isDragging = ref(false);
    const notification = ref({
      show: false,
      message: '',
      type: 'success'
    });

    // 格式化显示的JSON
    const formattedJson = computed(() => {
      return JSON.stringify(excelData.value, null, 2);
    });

    // 检查JSON是否有效
    const isValidJson = computed(() => {
      try {
        if (!jsonInput.value.trim()) return false;
        JSON.parse(jsonInput.value);
        return true;
      } catch {
        return false;
      }
    });

    // 处理Excel文件上传
    const handleExcelUpload = event => {
      const file = event.target.files[0];
      if (file) {
        processExcelFile(file);
      }
    };

    // 处理拖放
    const dragOver = () => {
      isDragging.value = true;
    };
    const handleDrop = event => {
      isDragging.value = false;
      const file = event.dataTransfer.files[0];
      if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))) {
        processExcelFile(file);
      } else {
        showNotification('请上传有效的Excel文件 (.xlsx 或 .xls)', 'error');
      }
    };

    // 处理Excel文件
    const processExcelFile = file => {
      const reader = new FileReader();
      reader.onload = e => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, {
            type: 'array'
          });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          excelData.value = jsonData;
          showNotification('Excel文件转换成功!', 'success');
        } catch (error) {
          console.error('Error processing Excel file:', error);
          showNotification('处理Excel文件时出错', 'error');
        }
      };
      reader.onerror = () => {
        showNotification('读取文件时出错', 'error');
      };
      reader.readAsArrayBuffer(file);
    };

    // 复制JSON到剪贴板
    const copyJson = () => {
      navigator.clipboard.writeText(formattedJson.value).then(() => showNotification('JSON已复制到剪贴板', 'success')).catch(() => showNotification('复制失败', 'error'));
    };

    // 下载JSON文件
    const downloadJson = () => {
      const blob = new Blob([formattedJson.value], {
        type: 'application/json'
      });
      saveAs(blob, 'data.json');
      showNotification('JSON文件下载开始', 'success');
    };

    // 将JSON转换为Excel
    const convertJsonToExcel = () => {
      try {
        const json = JSON.parse(jsonInput.value);
        if (!Array.isArray(json)) {
          throw new Error('JSON数据应该是一个数组');
        }
        const worksheet = XLSX.utils.json_to_sheet(json);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // 生成Excel文件并创建下载链接
        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // 释放之前创建的URL
        if (excelFileUrl.value) {
          URL.revokeObjectURL(excelFileUrl.value);
        }
        excelFileUrl.value = URL.createObjectURL(blob);
        conversionError.value = '';
        showNotification('JSON转换成功! 点击下载Excel文件', 'success');
      } catch (error) {
        conversionError.value = `转换错误: ${error.message}`;
        showNotification('JSON转换失败', 'error');
      }
    };

    // 下载Excel文件
    const downloadExcel = () => {
      if (excelFileUrl.value) {
        saveAs(excelFileUrl.value, 'data.xlsx');
        showNotification('Excel文件下载开始', 'success');
      }
    };

    // 显示通知
    const showNotification = (message, type) => {
      notification.value = {
        show: true,
        message,
        type
      };
      setTimeout(() => {
        notification.value.show = false;
      }, 3000);
    };

    // 组件卸载时清理
    onUnmounted(() => {
      if (excelFileUrl.value) {
        URL.revokeObjectURL(excelFileUrl.value);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        class: _normalizeClass(["tab-button", {
          active: activeTab.value === 'excelToJson'
        }]),
        onClick: _cache[0] || (_cache[0] = $event => activeTab.value = 'excelToJson')
      }, " Excel转JSON ", 2), _createElementVNode("button", {
        class: _normalizeClass(["tab-button", {
          active: activeTab.value === 'jsonToExcel'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => activeTab.value = 'jsonToExcel')
      }, " JSON转Excel ", 2)]), _createElementVNode("div", _hoisted_4, [activeTab.value === 'excelToJson' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
        class: "upload-area",
        onDragover: _withModifiers(dragOver, ["prevent"]),
        onDrop: _withModifiers(handleDrop, ["prevent"])
      }, [_createElementVNode("input", {
        type: "file",
        id: "excel-upload",
        accept: ".xlsx, .xls",
        onChange: handleExcelUpload,
        class: "file-input"
      }, null, 32), _hoisted_6], 32), excelData.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
        class: "result-header"
      }, [_hoisted_8, _createElementVNode("div", {
        class: "action-buttons"
      }, [_createElementVNode("button", {
        onClick: copyJson,
        class: "action-button"
      }, [_hoisted_9, _createTextVNode(" 复制JSON ")]), _createElementVNode("button", {
        onClick: downloadJson,
        class: "action-button"
      }, [_hoisted_10, _createTextVNode(" 下载JSON ")])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("pre", null, _toDisplayString(formattedJson.value), 1)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activeTab.value === 'jsonToExcel' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => jsonInput.value = $event),
        placeholder: "请输入有效的JSON数据，例如：[{name: '张三', age: 25}, {name: '李四', age: 30}]",
        class: "json-textarea"
      }, null, 512), [[_vModelText, jsonInput.value]])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
        onClick: convertJsonToExcel,
        disabled: !isValidJson.value,
        class: "convert-button"
      }, " 转换为Excel ", 8, _hoisted_15), excelFileUrl.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: downloadExcel,
        class: "download-button"
      }, " 下载Excel文件 ")) : _createCommentVNode("", true)]), conversionError.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(conversionError.value), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), notification.value.show ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["notification", notification.value.type])
      }, _toDisplayString(notification.value.message), 3)) : _createCommentVNode("", true)]);
    };
  }
};